import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './header.module.css';
import NavLinks from './nav-links';
import MobileMenu from '../mobile-menu/mobile-menu';
import SmartLink from '../common/smart-link';

const SCROLL_THRESHOLD = 20;

export default function Header() {
  const { pathname } = useLocation();
  const headerRef = useRef<HTMLElement | null>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [atTop, setAtTop] = useState(true);

  // Only hide logo on Home page (index route) when at top; other pages always show logo
  const isHomePage = pathname === '/' || pathname === '';
  const showTransparentHeader = isHomePage && atTop;

  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;
    let lastScrollTop = 0;

    const onScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setAtTop(scrollTop < SCROLL_THRESHOLD);
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }
      lastScrollTop = scrollTop;
    };
    header.style.transition = 'transform 0.3s ease-in-out';
    onScroll(); // init
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMobileOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <header
      className={`${styles.header} ${showTransparentHeader ? styles.headerTransparent : ''}`}
      ref={headerRef}
    >
      <div className={styles.container}>
        <div className={styles.headerContent}>
          <div className={styles.logo}>
            <SmartLink href="/#hero" className={styles.logoLink}>
              <h1>Meghan Rabbitt</h1>
            </SmartLink>
          </div>

          <nav className={styles.nav}>
            <NavLinks onLinkClick={() => setMobileOpen(false)} />
          </nav>
          <button
            className={styles.mobileMenuToggle}
            aria-label="Toggle mobile menu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((s) => !s)}
          >
            <span className={styles.hamburgerLine}></span>
            <span className={styles.hamburgerLine}></span>
            <span className={styles.hamburgerLine}></span>
          </button>
        </div>
      </div>

      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </header>
  );
}
